import React from "react";

const BatteryEmpty = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M13.6667 1H2.58333C1.70888 1 1 1.70888 1 2.58333V8.91667C1 9.79112 1.70888 10.5 2.58333 10.5H13.6667C14.5411 10.5 15.25 9.79112 15.25 8.91667V2.58333C15.25 1.70888 14.5411 1 13.6667 1Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.25 4.16663H16.4375C16.5425 4.16663 16.6432 4.20833 16.7174 4.28256C16.7916 4.3568 16.8333 4.45748 16.8333 4.56246V6.93746C16.8333 7.04244 16.7916 7.14312 16.7174 7.21736C16.6432 7.29159 16.5425 7.33329 16.4375 7.33329H15.25V4.16663Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default BatteryEmpty;
